import { init as initCategories } from './animated-categories'
import { init as initArticlesCarousel } from './articles-carousel'
import { init as initCarousel } from './carousel'
import { init as initContact } from './contact'
import { init as initCustomDownload } from './custom-download'
import { init as initFaq } from './faq'
import { init as initFooter } from './footer'
import { init as initResources } from './resources'
import { init as initSamples } from './samples'
import { init as initSlider } from './slider'
import { init as initSlideshow } from './slideshow'

const logErrors = function (err: unknown): void {
  console.error(err)
}

initFooter().catch(logErrors)
initSlideshow().catch(logErrors)
initCarousel().catch(logErrors)
initArticlesCarousel().catch(logErrors)
initCustomDownload().catch(logErrors)
initContact().catch(logErrors)
initResources().catch(logErrors)
initFaq().catch(logErrors)
initCategories().catch(logErrors)
initSlider().catch(logErrors)
initSamples().catch(logErrors)
